export class CheckBaseChargeModel {
    intLinkNo: number
    intLinkType: number
    strIType: string
    intClinicNo: number

    constructor(
        intLinkNo: number,
        intLinkType: number,
        strIType: string,
        intClinicNo: number
    ) {
        this.intLinkNo = intLinkNo
        this.intLinkType = intLinkType
        this.strIType = strIType
        this.intClinicNo = intClinicNo
    }
}